import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";
// 获取列表
export const getLocationBill = data => {
  return axios.request({
    url: "/finance/hq/kw/bill/index",
    method: "post",
    data
  });
};
export const getDetails = params => {
  return axios.request({
		url: `/finance/hq/kw/bill/read/${params.id}`,
    method: "get",
    params
  });
};

export const update = data => {
  return axios.request({
    url: `/finance/hq/kw/bill/update/${data.id}`,
    method: "put",
    data
  });
};


export const confirmBill = data => {
  return axios.request({
    url: `/finance/hq/kw/bill/confirm/${data.id}`,
    method: "post",
    data
  });
};
export const writeOffBill = data => {
  return axios.request({
    url: `/finance/hq/kw/bill/audit/${data.id}`,
    method: "post",
    data
  });
};

export const delItem = data => {
  return axios.request({
    url: `/finance/hq/kw/bill/del/${data.id}`,
    method: "delete",
    data
  });
};

export const sync = () =>{
	return axios.request({
	  url: `/finance/hq/kw/bill/sync`,
	  method: "get",
	});
}

export const getComplexDetails = params => {
  return axios.request({
    url: `/finance/hq/kw/bill/complex?id=${params.id}`,
    method: "get",
  });
}


export const exportLbApi = id => {
  return axios.request({
    url: `/finance/bill/exportClientLB`,
    method: "post",
    data: {
      id
    }
  })
}
